import { TicketStatus } from "@remi/enums/ticket/status";
import { entries } from "@remi/ts-utils";

const TICKET_STATUS_GROUP = {
  [TicketStatus.TRIAGE]: "active",
  [TicketStatus.OPEN]: "active",
  [TicketStatus.RESOLVED]: "terminal",
  [TicketStatus.CANCELED]: "terminal",
} as const satisfies Record<TicketStatus, "active" | "terminal">;

export const ACTIVE_TICKET_STATUSES = entries(TICKET_STATUS_GROUP)
  .filter(([, group]) => group === "active")
  .map(([status]) => status);

export const OPEN_TICKET_STATUSES = [TicketStatus.OPEN] as const;
export const TRIAGE_TICKET_STATUSES = [TicketStatus.TRIAGE] as const;
